type MascotProps = {
  label: string;
};

export function LoginMascot({ label }: MascotProps) {
  return (
    <div className="mascot-wrap" aria-label={label}>
      <style>{`
        .mascot-wrap{position:relative;width:220px;height:220px;margin:0 auto;animation:mascot-float 5s ease-in-out infinite}
        .mascot-wrap .mascot-glow{position:absolute;inset:-20px;border-radius:50%;background:radial-gradient(circle,rgba(110,231,183,.35),transparent 70%);animation:mascot-glow 4s ease-in-out infinite;z-index:0}
        .mascot-wrap svg{position:relative;z-index:1;display:block}
        @keyframes mascot-float{0%,100%{transform:translateY(0)}50%{transform:translateY(-10px)}}
        @keyframes mascot-glow{0%,100%{opacity:.6;transform:scale(1)}50%{opacity:1;transform:scale(1.06)}}
        .mascot-eye{animation:mascot-blink 4.5s ease-in-out infinite}
        @keyframes mascot-blink{0%,92%,100%{transform:scaleY(1)}96%{transform:scaleY(0.1)}}
        .mascot-hand{transform-origin:36px 74px;animation:mascot-wave 3.2s ease-in-out infinite}
        @keyframes mascot-wave{0%,100%{transform:rotate(0deg)}10%,30%{transform:rotate(-16deg)}20%{transform:rotate(12deg)}40%{transform:rotate(0deg)}}
        .mascot-leaf{animation:mascot-leaf 5s ease-in-out infinite;transform-origin:50px 26px}
        @keyframes mascot-leaf{0%,100%{transform:rotate(-4deg)}50%{transform:rotate(6deg)}}
      `}</style>
      <div className="mascot-glow" />
      <svg width="220" height="220" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g className="mascot-leaf">
          <path d="M50 30C50 18 58 12 66 12C66 26 58 32 50 30Z" fill="#6EE7B7" />
          <path d="M50 30C50 18 42 12 36 12C36 26 44 32 50 30Z" fill="#A7F3D0" />
        </g>
        <path d="M30 22h60v66c0 6-5 10-10 10H40c-5 0-10-4-10-10V22Z" fill="#34D399" />
        <path d="M30 22h60v66c0 6-5 10-10 10H40c-5 0-10-4-10-10V22Z" fill="none" stroke="#059669" strokeWidth="2" />
        <circle cx="42" cy="34" r="2.6" fill="#064E3B" className="mascot-eye" />
        <circle cx="62" cy="34" r="2.6" fill="#064E3B" className="mascot-eye" />
        <path d="M46 42q6 5 16 0" stroke="#064E3B" strokeWidth="2.2" strokeLinecap="round" fill="none" />
        <circle cx="66" cy="30" r="6" fill="#D1FAE5" stroke="#059669" strokeWidth="2" />
        <circle cx="66" cy="30" r="1.8" fill="#064E3B" />
        <circle cx="22" cy="30" r="6" fill="#A7F3D0" stroke="#059669" strokeWidth="2" />
        <g className="mascot-hand">
          <path d="M78 66c6-2 10 4 8 10-2 6-8 6-9 2" fill="#34D399" />
          <circle cx="85" cy="76" r="3.2" fill="#A7F3D0" stroke="#059669" strokeWidth="1.6" />
        </g>
        <path d="M30 78c8-6 16-6 24 0s16 6 24-2" stroke="#10B981" strokeWidth="2.4" strokeLinecap="round" fill="none" />
      </svg>
    </div>
  );
}